export const ADVANCE_SEARCH_API_URL = '/advance-search';